import React, { FunctionComponent, useState } from 'react';
import WideContent from 'core/layout/content/wide-content';
import { AdminProductDetail } from 'api';
import Translate from 'ui/atoms/translate';
import IssuerCreateCampaign from './create-campaign';
import ProductCampaignsTable from './campaigns-table';
import { ISSUER_ROUTES } from 'apps/issuer/pages/routes.config';
import useGoTo from 'hooks/use-go-to';
import { currentTokenHasManageDistributionPermission } from 'src/apps/issuer/helpers/tokenPermissions';

interface ProductCampaignProps {
  hasListings: boolean;
  product: AdminProductDetail;
  productId: string;
  setFilterPopupHeight?: (height: number) => void;
}

const ProductCampaigns: FunctionComponent<ProductCampaignProps> = ({
  hasListings,
  product,
  productId,
  setFilterPopupHeight,
}) => {
  const [forceDataLoad, setForceDataLoad] = useState(false);

  const goToCampaignDetails = useGoTo(ISSUER_ROUTES.campaignDetails);

  const canManage = currentTokenHasManageDistributionPermission(product);

  return (
    <WideContent
      title={<Translate name="dashboard.issuerCampaigns" />}
      ignorePageTitle
      titleSpacing="medium"
      headerPanel={
        canManage ? (
          <IssuerCreateCampaign
            hasListings={hasListings}
            onCloseAfterSuccess={() => setForceDataLoad(true)}
            product={product}
          >
            <Translate name="campaignInvitation.create.long" />
          </IssuerCreateCampaign>
        ) : null
      }
    >
      <ProductCampaignsTable
        productId={productId}
        goToDetails={(campaignId: string) => goToCampaignDetails({ campaignId })}
        defaultLimit={10}
        forceDataLoad={forceDataLoad}
        setForceDataLoad={setForceDataLoad}
        skipFilterUrlSync={true}
        setFilterPopupHeight={setFilterPopupHeight}
      />
    </WideContent>
  );
};

export default ProductCampaigns;
